module.exports = __webpack_public_path__ + "static/media/dec 2020.22ff896a.svg";